module.exports = __webpack_public_path__ + "img/精准客户标签.393ad170.svg";